import { forwardRef, memo } from "react";
import { useIntl } from "react-intl";
import { Modal, Header, Image } from "semantic-ui-react";

// Styles
import "./MeHeyLanding.scss";

type MeHeyLandingAddLineModProps = {
  open: boolean;
  onClose: () => void;
};

const IMAGES = {
  qrCode: "/static/images/mehey_landing/MeHeyOAsupport.png",
};

const MeHeyLandingAddLineMod = memo(
  forwardRef<any, MeHeyLandingAddLineModProps>((props, ref) => {
    const intl = useIntl();

    return (
      <Modal
        className={props.open ? "fade-in" : "fade-out"}
        ref={ref}
        open={props.open}
        onClose={props.onClose}
        style={{ width: "max-content" }}
      >
        <div className="download-mod">
          <div style={{ textAlign: "center" }}>
            <Header
              style={{
                fontSize: "2rem",
                marginBottom: "1rem",
                display: "inline-block",
                padding: "4px 1rem 0 1rem",
              }}
              as="h2"
            >
              {intl.formatMessage({ id: "ช่องทางสำหรับติดต่อสอบถาม" })}
            </Header>
          </div>

          <div style={{ textAlign: "center" }}>
            <label>{intl.formatMessage({ id: "Scan เพื่อเพิ่มเพื่อน" })}</label>
            <div style={{ display: "flex", justifyContent: "center", paddingTop: "1rem" }}>
              <div className="qr-code-gradient">
                <Image src={IMAGES.qrCode} size="medium" />
              </div>
            </div>
          </div>
        </div>
      </Modal>
    );
  })
);

export default MeHeyLandingAddLineMod;
